module.exports = __webpack_public_path__ + "static/assets/dbb64ea577f4998369992e3898775f85.png";